export enum Platforms {
  SalespersonApp = 'app_vendedor',
  SupplierApp = 'app_financeiro',
  MerchantPayment = 'modulo_pagamento',
}
